import 'swiper/css';
import 'swiper/css/pagination';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import {
  Container,
  Header,
  Brand,
  VideoBackground,
  Content,
  About,
  CarouselSection,
  Card,
  CardInfo,
  FullScreen,
  Media,
  Footer,
  CardImage
} from "./styles";

import mov from "./assets/sweatshirt.mp4"
import IMG_0001 from "./assets/sweatshirt/IMG_0001.jpeg";
import IMG_0002 from "./assets/sweatshirt/IMG_0002.jpeg";
import IMG_0004 from "./assets/sweatshirt/IMG_0004.jpeg";
import IMG_0005 from "./assets/sweatshirt/IMG_0005.jpeg";
import IMG_0006 from "./assets/sweatshirt/IMG_0006.jpeg";
import IMG_0007 from "./assets/sweatshirt/IMG_0007.jpeg";
import IMG_0008 from "./assets/sweatshirt/IMG_0008.jpeg";
import IMG_0009 from "./assets/sweatshirt/IMG_0009.jpeg";
import IMG_0010 from "./assets/sweatshirt/IMG_0010.jpeg";
import IMG_0011 from "./assets/sweatshirt/IMG_0011.jpeg";
import IMG_0012 from "./assets/sweatshirt/IMG_0012.jpeg";
import IMG_0000 from "./assets/sweatshirt/IMG_0000.jpg";

export default function Home() {
  const produtos = [
    {
      img: IMG_0001,
      codigo: "Conjunto Premium com capuz Hoodie",
      precoOriginal: "R$ 594,90",
      precoLancamento: "R$ 497,00",
      link: "https://mpago.li/1Rm4wUq"
    },
    {
      img: IMG_0002,
      codigo: "Conjunto Premium sem capuz Crewneck",
      precoOriginal: "R$ 554,00",
      precoLancamento: "R$ 467,00",
      link: "https://mpago.li/1DbxZZq"
    },
    {
      img: IMG_0012,
      codigo: "Conjunto Premium com capuz Hoodie",
      precoOriginal: "R$ 594,00",
      precoLancamento: "R$ 497,00",
      link: "https://mpago.li/1Rm4wUq"
    },
    {
      img: IMG_0004,
      codigo: "Conjunto Premium sem capuz Crewneck",
      precoOriginal: "R$ 554,00",
      precoLancamento: "R$ 467,00",
      link: "https://mpago.li/1DbxZZq"
    },
    {
      img: IMG_0005,
      codigo: "Conjunto Premium com capuz Hoodie",
      precoOriginal: "R$ 594,00",
      precoLancamento: "R$ 497,00",
      link: "https://mpago.li/1Rm4wUq"
    },
    {
      img: IMG_0008,
      codigo: "Conjunto Premium sem capuz Crewneck",
      precoOriginal: "R$ 554,00",
      precoLancamento: "R$ 467,00",
      link: "https://mpago.li/1DbxZZq"
    },
    {
      img: IMG_0006,
      codigo: "Conjunto Premium com capuz Hoodie",
      precoOriginal: "R$ 594,00",
      precoLancamento: "R$ 497,00",
      link: "https://mpago.li/1Rm4wUq"
    },
    {
      img: IMG_0007,
      codigo: "Conjunto Premium sem capuz Crewneck",
      precoOriginal: "R$ 554,00",
      precoLancamento: "R$ 467,00",
      link: "https://mpago.li/1DbxZZq"
    },
    {
      img: IMG_0009,
      codigo: "Conjunto Premium sem capuz Crewneck",
      precoOriginal: "R$ 554,00",
      precoLancamento: "R$ 467,00",
      link: "https://mpago.li/1DbxZZq"
    },
    {
      img: IMG_0010,
      codigo: "Conjunto Premium sem capuz Crewneck",
      precoOriginal: "R$ 554,00",
      precoLancamento: "R$ 467,00",
      link: "https://mpago.li/1DbxZZq"
    },
    {
      img: IMG_0011,
      codigo: "Conjunto Premium sem capuz Crewneck",
      precoOriginal: "R$ 554,00",
      precoLancamento: "R$ 467,00",
      link: "https://mpago.li/1DbxZZq"
    },
  ];

  return (
    <Container>
      <Header>
        <VideoBackground autoPlay muted playsInline loop>
          <source src={mov} type="video/mp4" />
        </VideoBackground>

        <Brand>
          <h1>Maria<small>&amp;</small>Daniel</h1>
        </Brand>

        <Content>
          <h1>O básico que nunca é comum</h1>
          <p>
            A nova edição 2026 apresenta uma coleção que reflete atitude e exclusividade.
            Peças pensadas como ponto de partida para um estilo conectado à dinâmica de uma realidade urbana em constante transformação.
          </p>
          <button onClick={() => {
            const section = document.getElementById('colecao');
            if (section) {
              section.scrollIntoView({ behavior: 'smooth' });
            }
          }}>
            Conhecer coleção
          </button>
        </Content>
      </Header>

      <About>
        <div className="content">
          <p className="highlight">Na <strong>M&amp;D</strong>, o básico nunca é comum.</p>
          <h2>A vida é feita de conexões</h2>


          <div className="story">
            <p>Essa é a nossa história. <strong>M de Maria & D de Daniel</strong>, dois corações que se uniram para criar o conforto que você merece.</p>
            <p>Apresentamos a <strong>M&amp;D</strong>: onde cada moletom é mais que uma peça; é um convite para você sentir a exclusividade, a maciez e a atenção em cada detalhe. Pensamos em você, em cada fibra.</p>
            <p className='make'>Feito com carinho no Brasil,<br />para aquecer seus melhores momentos.</p>
          </div>

          <p className="signature">
            Com amor,<br />
            Maria & Daniel
          </p>
        </div>
      </About>

      <CarouselSection id="colecao">
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          slidesPerView="auto"
          spaceBetween={24}
          grabCursor={true}
          style={{ position: "relative", paddingBottom: "44px" }}
        >
          {produtos.map((produto, i) => (
            <SwiperSlide key={i} style={{ width: "320px" }}>
              <Card>
                <CardImage>
                  <img src={produto.img} alt={produto.codigo} />
                </CardImage>

                <CardInfo>
                  <span>{produto.codigo}</span>
                  <span className="price-original">Original: {produto.precoOriginal}</span>
                  <span className="price-launch">Lançamento: {produto.precoLancamento}</span>
                  <div className='div-size'><span>Tamanhos:</span><span className='size'>P</span><span className='size'>M</span><span className='size'>G</span><span className='size'>GG</span></div>
                  <button onClick={() => window.open(produto.link, "_blank")}>
                    <i className="bi bi-bag-check-fill"></i> Comprar
                  </button>
                </CardInfo>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </CarouselSection>

      <FullScreen>
        <div className="description">
          <h1>Conforto que transforma</h1>
          <p>
            Cada peça da coleção M&D é pensada para unir estilo e bem-estar, traduzindo atitude e exclusividade em cada detalhe.
          </p>
        </div>
        <img src={IMG_0000} alt="Coleção M&D" />
      </FullScreen>


      <Media>
        <h2>Conecte-se conosco</h2>
        <p>Siga nossas redes sociais e fique por dentro de novidades, coleções exclusivas e momentos que inspiram a M&D.</p>

        <div className="icons">
          <a href="https://www.instagram.com/moletommdoficial" target="_blank" rel="noopener noreferrer">
            <i className="fi fi-brands-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/company/moletommdoficial" target="_blank" rel="noopener noreferrer">
            <i className="fi fi-brands-linkedin"></i>
          </a>
          <a href="https://www.tiktok.com/@medical.science.l?_r=1&_t=ZS-94u1awrN3PU" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-tiktok"></i>
          </a>
          <a href="https://wa.me/+5511947414529" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-whatsapp"></i>
          </a>
        </div>
      </Media>

      <Footer>
        M&D®️ - Marca registrada sob processo nº 942869664. Todos os direitos reservados!
        <a href="mailto:moletommd@gmail.com">moletommd@gmail.com</a>
      </Footer>

    </Container>
  );
}